<template>
  <div class="panel" :class="levelClassMap[level]">
    <div
      class="panel-heading"
      role="button"
      @click="collapsed = !collapsed">
      <h3 class="panel-title">{{ levelLabel }}</h3>
      <i :class="collapsed ? 'fa fa-chevron-up' : 'fa fa-chevron-down'" />
    </div>
    <collapse v-model="collapsed">
      <div class="panel-body">
        <div class="form-group">
          <label :for="`${uuid}-text`" class="control-label annual-target-header">Annual Target | {{ levelLabel }}</label>
          <small class="help-block">Markdown NOT supported</small>
          <textarea
            :id="`${uuid}-text`"
            rows="4"
            class="form-control"
            v-model="textInternal"
            @input="$emit('update:text', textInternal)"/>
        </div>

        <slot/>

        <p class="text-right">
          <small class="text-muted">{{ uuid }} &nbsp; <a
            :href="legacyEditURL"
            target="_blank"
            title="Legacy edit page">Edit in legacy edit page</a></small>
        </p>
      </div>
    </collapse>
  </div>
</template>

<script>
import { AccessPointsUtil } from '@/components/goals/common/access_points'
import { toolkitUrls } from '@/links'

export default {
  name: 'EditAccessPoint',
  props: {
    uuid: {
      type: String,
      required: true
    },
    level: {
      type: String,
      validator: val => AccessPointsUtil.orderedValues.includes(val),
      required: true
    },
    text: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      textInternal: this.text || '',
      levelClassMap: {
        [AccessPointsUtil.valuesMap.GRADE_LEVEL]: 'panel-primary',
        [AccessPointsUtil.valuesMap.APPROACHING]: 'panel-info',
        [AccessPointsUtil.valuesMap.DEVELOPING]: 'panel-default'
      },
      collapsed: true
    }
  },
  computed: {
    levelLabel() {
      return AccessPointsUtil.labelsMap[this.level]
    },
    legacyEditURL() {
      return toolkitUrls.editorLinks.editGoal(this.uuid)
    }
  },
  watch: {
    text(newValue) {
      this.textInternal = newValue
    }
  }
}
</script>

<style lang="less" scoped>
.panel-heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.fa {
  font-size: var(--text-lg);
}

.panel-body {
  padding-left: var(--spacing-5xl);
}

.annual-target-header {
  font-size: var(--text-xl);
  font-weight: var(--font-medium);
  margin-left: calc(0px - var(--spacing-3xl));;
}
</style>
